var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":_vm.modalID,"hide-footer":"","scrollable":_vm.scrollable,"title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }